import React, { useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
  TextField,
  IconButton,
  Divider,
  Card,
  CardActionArea,
  useTheme,
} from "@mui/material";

import QrCode2Icon from "@mui/icons-material/QrCode2";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";

import { useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../../../Theme";
import store from "../../..";

const Payment = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const location = useLocation();

  const CompanyQRCode = sessionStorage.getItem("CompanyQRCode");
  console.log("🚀 ~ Payment ~ CompanyQRCode:", CompanyQRCode)
  const amount = location?.state?.amount || 140;

  const [paymentMethod, setPaymentMethod] = useState("QR");
  const [transactionId, setTransactionId] = useState("");
  const [screenshot, setScreenshot] = useState(null);

  const copyUPI = () => {
    navigator.clipboard.writeText("Subramani@upi");
  };

  const handleFileChange = (e) => {
    setScreenshot(e.target.files[0]);
  };

  const handlePlaceOrder = () => {
    console.log({
      paymentMethod,
      transactionId,
      screenshot,
    });
  };

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: "#f7f4f2",
        minHeight: "100vh",
      }}
    >
      {/* Header */}

      <Box mb={3}>
        {/* <Box display="flex" alignItems="center" gap={1}>
          <ShieldOutlinedIcon
            sx={{
              color: "#f97316",
              fontSize: 18,
            }}
          />
          <Typography
            sx={{
              color: "#f97316",
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            Secured payment
          </Typography>
        </Box> */}

        <Typography
          variant="h3"
          fontWeight="bold"
          color={colors.grey[100]}
        >
          Payment
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {/* Left Section */}

        <Grid item xs={12} md={8}>
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderRadius: 3,
            }}
          >
            <Typography variant="h5" fontWeight={600}>
              Select payment option
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              mt={1}
              mb={3}
            >
              Complete payment first, then upload the
              transaction proof.
            </Typography>

            {/* Payment Options */}

            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Card
                  sx={{
                    border:
                      paymentMethod === "QR"
                        ? "2px solid #f97316"
                        : "1px solid #e5e7eb",
                    borderRadius: 3,
                    height:"120px",
                    width:"100%",
                  }}
                >
                  <CardActionArea
                    onClick={() => setPaymentMethod("QR")}
                  >
                    <Box p={2}>
                      <QrCode2Icon
                        sx={{
                          color: "#f97316",
                          mb: 1,
                        }}
                      />

                      <Typography fontWeight={600}>
                        QR code
                      </Typography>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                      >
                        Scan and complete payment from any
                        UPI app.
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Card
                  sx={{
                    border:
                      paymentMethod === "UPI"
                        ? "2px solid #f97316"
                        : "1px solid #e5e7eb",
                    borderRadius: 3,
                     height:"120px",
                    width:"100%",
                  }}
                >
                  <CardActionArea
                    onClick={() => setPaymentMethod("UPI")}
                  >
                    <Box p={2}>
                      <AccountBalanceWalletIcon
                        sx={{
                          color: "#f97316",
                          mb: 1,
                        }}
                      />

                      <Typography fontWeight={600}>
                        UPI ID
                      </Typography>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                      >
                        Pay directly using UPI.
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Card
                  sx={{
                    border:
                      paymentMethod === "BANK"
                        ? "2px solid #f97316"
                        : "1px solid #e5e7eb",
                    borderRadius: 3,
                    height:"120px",
                    width:"100%",
                  }}
                >
                  <CardActionArea
                    onClick={() => setPaymentMethod("BANK")}
                  >
                    <Box p={2}>
                      <AccountBalanceIcon
                        sx={{
                          color: "#f97316",
                          mb: 1,
                        }}
                      />

                      <Typography fontWeight={600}>
                        Bank transfer
                      </Typography>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                      >
                        Transfer to bank account.
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>

            {/* Payment Details */}

            <Paper
              variant="outlined"
              sx={{
                mt: 3,
                p: 3,
                borderRadius: 3,
              }}
            >
              {paymentMethod === "QR" && (
                <Box textAlign="center">
                  <img
                    // src="/images/qr-placeholder.png"
                    src={store.getState().globalurl.EventsimageUrl + CompanyQRCode || "./public/QRimg.PNG"}
                    alt="QR Code"
                    width="180"
                  />

                  <Typography
                    fontWeight={600}
                    mt={2}
                  >
                    Scan and pay Rs. {amount}
                  </Typography>
                </Box>
              )}

              {paymentMethod === "UPI" && (
                <>
                  <Typography
                    fontWeight={600}
                    mb={2}
                  >
                    UPI ID
                  </Typography>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                      background: "#f5f5f5",
                      p: 2,
                      borderRadius: 2,
                    }}
                  >
                    <Typography fontWeight={600}>
                      subramani@upi
                    </Typography>

                    <IconButton onClick={copyUPI}>
                      <ContentCopyIcon />
                    </IconButton>
                  </Box>
                </>
              )}

              {paymentMethod === "BANK" && (
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography>Name</Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography fontWeight={600}>
                      Subramani
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography>Branch</Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography fontWeight={600}>
                      Kolathur Branch
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography>IFSC</Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography fontWeight={600}>
                      KOLR0000001
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography>
                      Account Number
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography fontWeight={600}>
                      50011025632587
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Paper>
          </Paper>

          {/* Upload Proof */}

          <Paper
            elevation={2}
            sx={{
              mt: 3,
              p: 3,
              borderRadius: 3,
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              mb={1}
            >
              <UploadFileOutlinedIcon />
              <Typography
                variant="h5"
                fontWeight={600}
              >
                Payment proof
              </Typography>
            </Box>

            <Typography
              color="text.secondary"
              mb={3}
            >
              Upload screenshot is mandatory.
              Transaction ID is optional.
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Transaction ID"
                  focused
                  value={transactionId}
                  onChange={(e) =>
                    setTransactionId(e.target.value)
                  }
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Button
                  component="label"
                  variant="outlined"
                  fullWidth
                  sx={{ height: 56 }}
                >
                  Upload Screenshot

                  <input
                    hidden
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Right Section */}

        <Grid item xs={12} md={4}>
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderRadius: 3,
              position: "sticky",
              top: 20,
            }}
          >
            <Typography
              variant="h5"
              fontWeight={600}
            >
              Invoice total
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              mt={1}
            >
              1 Item
            </Typography>

            <Box mt={3}>
              <Box
                display="flex"
                justifyContent="space-between"
              >
                <Typography>Subtotal</Typography>
                <Typography>
                  Rs. {amount}
                </Typography>
              </Box>

             

              <Divider sx={{ my: 2 }} />

              <Box
                display="flex"
                justifyContent="space-between"
              >
                <Typography
                  fontWeight={700}
                  variant="h5"
                >
                  Total
                </Typography>

                <Typography
                  fontWeight={700}
                  variant="h5"
                >
                  Rs. {amount}
                </Typography>
              </Box>

              <Button
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  backgroundColor: "secondary",
                  height: 48,
                }}
                onClick={handlePlaceOrder}
              >
                Complete Payment
              </Button>

              <Button
                fullWidth
                variant="outlined"
                sx={{ mt: 2 }}
                onClick={() => navigate(-1)}
              >
                Back to checkout
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Payment;